import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = sessionStorage.getItem("isAuthenticated") === "true";
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/fr8auctions" replace state={{ from: location }} />;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
